import React from 'react';
import styled from 'styled-components';
import type { SanitySupportArticleSectionHeading } from '@repo/models/gatsby-graphql-types';

const TableOfContentsWrapper = styled.div`
  margin-bottom: 2rem;
`;

const TableOfContentsHeading = styled.h2``;

const TableOfContentsList = styled.ul`
  list-style: none;
  padding-left: 0;
`;

const TableOfContentsListItem = styled.li`
  padding: 0.25em 0 0.25em 0;
`;

interface SupportArticleTableOfContentsProps {
  sections?: SanitySupportArticleSectionHeading[];
}

const scrollToLink = function (event) {
  event.preventDefault();
  document.getElementById(event.target.dataset.anchorid)?.scrollIntoView();
};

function SupportArticleTableOfContents({
  sections,
}: Readonly<SupportArticleTableOfContentsProps>) {
  const headings = sections?.filter(
    s => s._type === 'supportArticleSectionHeading' && s.type !== 'h3'
  );

  return (
    <TableOfContentsWrapper>
      <TableOfContentsHeading>Table of Contents</TableOfContentsHeading>
      <TableOfContentsList>
        {headings?.map(h => (
          <TableOfContentsListItem key={h._key}>
            <a
              href={`#${h._key}`}
              data-anchorid={h._key}
              onClick={scrollToLink}
            >
              {h.text}
            </a>
          </TableOfContentsListItem>
        ))}
      </TableOfContentsList>
    </TableOfContentsWrapper>
  );
}

export default SupportArticleTableOfContents;
